import moment from 'moment';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Button, DatePicker } from '../../common/components';
import { dateFormat } from '../../utils/constant';

// import { getMonthlyExportStatus } from '../../api/statements';

const CommonFilter = ({
  title,
  generateReport,
  debounceApiCall,
  type,
  selectDue,
  fromDate,
  toDate,
  searchText,
  setSearchText,
  setToDate,
  setFromDate,
  showStatusMessage,
}) => {
  const onSearchChange = (event) => {
    setSearchText(event.target.value);
    if (type === 'bulk') {
      const payload = {
        startDate: moment(fromDate).format(dateFormat.YEAR_MONTH_DAY),
        endDate: moment(toDate).format(dateFormat.YEAR_MONTH_DAY),
        opiOrName: event.target.value,
        timezone: moment.tz.guess(),
        ...(type === 'bulk' && {
          page: 1,
          limit: 10,
        }),
        dueSelected: selectDue,
      };
      debounceApiCall(payload);
    }
  };
  const generateClick = () => {
    const payload = {
      startDate: moment(fromDate).format(dateFormat.YEAR_MONTH_DAY),
      endDate: moment(toDate).format(dateFormat.YEAR_MONTH_DAY),
      ...(searchText?.length > 0 && {
        opiOrName: searchText,
      }),
      ...(type === 'bulk' && {
        page: 1,
        limit: 10,
        dueSelected: true,
      }),
      timezone: moment.tz.guess(),
    };
    generateReport(payload, 'click');
  };
  const monthlyExport = () => {
    const payload = {
      timezone: moment.tz.guess(),
    };
    generateReport(payload, 'monthlyExport');
  };
  const monthlyExportStatus = () => {
    const payload = {
      timezone: moment.tz.guess(),
    };
    generateReport(payload, 'monthlyExportStatus');
  };

  const dateOptionsGenerator = (durationType) => {
    const options = {
      minDate: null,
      maxDate: new Date(),
      dateFormat: dateFormat.M_D_Y,
    };
    if (durationType === 'toDate') {
      options.minDate = fromDate ? moment(fromDate)._d : null;
    }
    return options;
  };
  const getDisabledState = () => {
    if (type === 'individual') {
      return fromDate && toDate && searchText;
    }
    return fromDate && toDate;
  };
  return (
    <div>
      {type === 'individual' && (
        <Row className="generate-card">
          <Col lg={6} className="generate-card-item">
            <Row>
              <Col lg={9} className="generate-label">
                <h3 className="statement-heading">{title}</h3>
                <div className="common-local-search w-100 common-statement-search ">
                  <i className="fas fa-search" />
                  {/* later use input from common components */}
                  <input
                    className="local-search"
                    placeholder="Search using OPI or Contract Number "
                    type="search"
                    value={searchText}
                    onChange={onSearchChange}
                  />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={6}>
            <Row className="generate-card-item1">
              <Col lg={4} className="date-picker-g">
                <DatePicker
                  required
                  formInput={false}
                  placeholder="Date"
                  label="From"
                  name="from date"
                  kind="md"
                  value={fromDate}
                  onChange={([selectedDate]) => {
                    setToDate(null);
                    setFromDate(null);
                    setFromDate(selectedDate);
                  }}
                  options={dateOptionsGenerator('fromDate')}
                />
              </Col>
              <Col lg={4} className="date-picker-g">
                <DatePicker
                  required
                  formInput={false}
                  placeholder="Date"
                  label="To"
                  name="to date"
                  kind="md"
                  value={toDate}
                  onChange={([selectedDate]) => {
                    setToDate(selectedDate);
                  }}
                  options={dateOptionsGenerator('toDate')}
                  disabled={!fromDate}
                />
              </Col>

              <Col lg={4} className="generate-button-1">
                <Button disabled={!getDisabledState()} color="primary" onClick={generateClick}>
                  Generate
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {type === 'bulk' && (
        <Row className="generate-card">
          <Col lg={4} className="generate-card-item">
            <Row>
              <Col lg={12} className="generate-label">
                <h3 className="statement-heading">{title}</h3>
                <div className="common-local-search w-100 common-statement-search ">
                  <i className="fas fa-search" />
                  {/* later use input from common components */}
                  <input
                    className="local-search"
                    placeholder="Search using OPI or Contract Number "
                    type="search"
                    value={searchText}
                    onChange={onSearchChange}
                  />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={8}>
            <Row className="generate-card-item1">
              <Col lg={3} className="date-picker-g">
                <DatePicker
                  required
                  formInput={false}
                  placeholder="Date"
                  label="From"
                  name="from date"
                  kind="md"
                  value={fromDate}
                  onChange={([selectedDate]) => {
                    setToDate(null);
                    setFromDate(null);
                    setFromDate(selectedDate);
                  }}
                  options={dateOptionsGenerator('fromDate')}
                />
              </Col>
              <Col lg={3} className="date-picker-g">
                <DatePicker
                  required
                  formInput={false}
                  placeholder="Date"
                  label="To"
                  name="to date"
                  kind="md"
                  value={toDate}
                  onChange={([selectedDate]) => {
                    setToDate(selectedDate);
                  }}
                  options={dateOptionsGenerator('toDate')}
                  disabled={!fromDate}
                />
              </Col>

              <Col lg={3} className="generate-button-1">
                <Button disabled={!getDisabledState()} color="primary" onClick={generateClick}>
                  Generate
                </Button>
              </Col>
              <Col lg={3} className="generate-button-1">
                <Button
                  color="primary"
                  onClick={monthlyExport}
                  className="monthly-generation-button"
                >
                  Monthly Generation
                </Button>
              </Col>
              {showStatusMessage ? (
                <Col lg={3} className="ml-auto ml-4 mt-3 text-center">
                  <div onClick={monthlyExportStatus} className="status-link">
                    Show Status
                  </div>
                </Col>
              ) : (
                ''
              )}
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
};
CommonFilter.propTypes = {
  title: PropTypes.string.isRequired,
  generateReport: PropTypes.func.isRequired,
  debounceApiCall: PropTypes.func,
  type: PropTypes.string.isRequired,
  selectDue: PropTypes.bool,
  onSelectDueClick: PropTypes.func,
  fromDate: PropTypes.objectOf(PropTypes.any),
  toDate: PropTypes.objectOf(PropTypes.any),
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
  setToDate: PropTypes.func.isRequired,
  setFromDate: PropTypes.func.isRequired,
  showStatusMessage: PropTypes.bool.isRequired,
};

CommonFilter.defaultProps = {
  fromDate: null,
  toDate: null,
  selectDue: false,
  onSelectDueClick: () => {},
  debounceApiCall: () => {},
};

export default CommonFilter;
